import { baseApi } from "./baseApi";

export interface SendCustomNotificationPayload {
  toName?: string;
  toEmail?: string;
  toPhone?: string;
  subject: string;
  message: string;
  sendEmail: boolean;
  sendSms: boolean;
  sendWhatsApp: boolean;
}

interface NotifyResult {
  success: boolean;
  message: string;
}

export const notificationsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    sendRequestEmail: builder.mutation<NotifyResult, string>({
      query: (id) => ({ url: `/Notifications/request/${id}/email`, method: "POST" }),
    }),
    sendRequestSms: builder.mutation<NotifyResult, string>({
      query: (id) => ({ url: `/Notifications/request/${id}/sms`, method: "POST" }),
    }),
    sendRequestWhatsApp: builder.mutation<NotifyResult, string>({
      query: (id) => ({ url: `/Notifications/request/${id}/whatsapp`, method: "POST" }),
    }),
    sendCustomNotification: builder.mutation<NotifyResult, SendCustomNotificationPayload>({
      query: (body) => ({ url: `/Notifications/send-custom`, method: "POST", body }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useSendRequestEmailMutation,
  useSendRequestSmsMutation,
  useSendRequestWhatsAppMutation,
  useSendCustomNotificationMutation,
} = notificationsApi;
